// Halo quick-view modal variant handle
(() => {
    const getHandle = () => 
        document.querySelector('.quickView[data-product-quickview-handle]')?.getAttribute('data-product-quickview-handle') ||
        document.querySelector('variant-quick-view-radios')?.getAttribute('data-url')?.split('/products/')[1];
    
    const updateAttrs = (handle, variantId) => {
        if (!handle) return;
        
        [
            '.halo-popup.halo-quick-view-popup',
            'variant-quick-view-radios',
            '.halo-quick-view-popup .price',
            ...Array.from(document.querySelectorAll('variant-quick-view-radios .product-form__label'))
        ].forEach(el => {
            const element = typeof el === 'string' ? document.querySelector(el) : el;
            element?.setAttribute('data-product-handle', handle);
            element?.setAttribute('data-variant-id', variantId);
        });
        
        window.Abra?.render?.();
    };
    
    document.addEventListener('quickview:opened', e => 
        setTimeout(() => {
            const picker = document.querySelector('variant-quick-view-radios');
            if (picker) {
                const variants = JSON.parse(picker.getAttribute('data-json'));
                updateAttrs(e.detail.handle || getHandle(), variants[0].id);
            }
        }, 100)
    );
    
    document.addEventListener('quickview:variant-changed', e => 
        updateAttrs(getHandle(), e.detail.variant.id)
    );
})();

// Cart auto-refresh
(() => {
    let isUpdating = false;
    
    const updateCart = () => {
        if (isUpdating) return;
        
        isUpdating = true;
        
        setTimeout(() => {
            Shopify.getCart((cart) => {
                window.sharedFunctions?.updateSidebarCart(cart);
                
                setTimeout(() => {
                    isUpdating = false;
                }, 1000);
            });
        }, 800);
    };
    
    document.addEventListener('cart-update', (e) => {
        if (!isUpdating) {
            updateCart();
        }
    });
})();

(() => {
    const toggleSubtotal = () => {
        const isAbraActive = 
        document.body.classList.contains('abra--applied') || 
        document.body.classList.contains('abra--activated');
        
        const subtotals = document.querySelectorAll('.productView-subtotal');
        subtotals.forEach(el => {
            el.style.display = isAbraActive ? 'none' : '';
        });
    };

    toggleSubtotal();
    
    const observer = new MutationObserver(() => toggleSubtotal());
    
    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
})();